import React from 'react';
import DateTimeDisplay from './DateTimeDisplay';
import { useCountdown } from '../../hooks/useCountdown';
import { TimeDisplay } from './TimeDisplay';


const ExpiredNotice = () => {
  return (
    <div className="expired-notice">
      <span>Expired!!!</span>
      <p>Please select a future date and time.</p>
    </div>
  );
};

const ShowCounter = ({ days, hours, minutes, seconds }) => {
  return (
    <div className="show-counter">
      <a
        href="https://tapasadhikary.com"
        target="_blank"
        rel="noopener noreferrer"
        className="countdown-link"
      >
        <DateTimeDisplay value={days} type={'Days'} isDanger={days <= 3} />
        <p>:</p>
        <DateTimeDisplay value={hours} type={'Hours'} isDanger={false} />
        <p>:</p>
        <DateTimeDisplay value={minutes} type={'Mins'} isDanger={false} />
        <p>:</p>
        <DateTimeDisplay value={seconds} type={'Seconds'} isDanger={false} />
      </a>
    </div>
  );
};
const ShowCounterSeconds = ({ hours,minutes,seconds,rateLimit }) => {
  
    return (
      <div className="show-counter">
          {rateLimit ? <TimeDisplay hh={hours} mm={minutes} ss={seconds < 0 ? 0: seconds} type={''} isDanger={hours == 0 && minutes == 0 && seconds <= 10} />
          :<DateTimeDisplay value={seconds < 0 ? 0: seconds} type={''} isDanger={seconds <= 5} />
          }
      </div>
    );
  };

const CountdownTimer = ({ targetDate,rateLimit }) => {
  
  const [days, hours, minutes, seconds] = useCountdown(targetDate);
  return (
    <ShowCounterSeconds
      days={days}
      hours={hours}
      minutes={minutes}
      seconds={seconds}
      rateLimit={rateLimit}
    />
  );
};

export default CountdownTimer;
